export class WalletNotFoundError implements Error {
  name = 'WalletNotFoundError'
  message = 'walletProvider.errors.walletNotFound'
}
